import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import './FloatingButton.css';

const FloatingButton = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <a href='https://drive.google.com/file/d/11Msn0h2RUEnZLZsYX7gzv67xGfFg7N0Q/view' target='_blank'>
        <button 
            className="floating-button"
            onClick={scrollToTop}
            aria-label="Scroll to top"
            >
            Portfolio  <FaArrowRight />
        </button>
    </a>
  );
};

export default FloatingButton; 